/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {
  dlsAlt,
  dlsColor,
  dlsTypography,
  dlsZIndex
} from '../theme/theme';
import {DLSTheme} from '../types/types';

export const styles = (theme: DLSTheme) => ({
  formPaper : {
    backgroundColor                : `${dlsColor('grey6')} !important`,
    maxWidth                       : '1068px',
    overflow                       : 'hidden',
    margin                         : 'auto',
    [theme.breakpoints.down('sm')] : {
      width     : '100%',
      maxHeight : '100% !important',
      margin    : '0px'
    }
  },

  paperScrollPaper : {
    maxHeight : 'calc(100% - 94px)'
  },

  scrollPaper : {
    flexDirection  : 'column',
    justifyContent : 'flex-end'
  },

  formWrapper : {
    padding                        : '0px 109px 0px',
    [theme.breakpoints.down('sm')] : {
      padding : '0px 0px 20px 0px'
    }
  },

  formWrapperCtc : {
    padding                        : '0px 85px 0px',
    [theme.breakpoints.down('sm')] : {
      padding : '0px 0px 20px 0px'
    }
  },

  formWrapperCtcAlt : {
    padding                        : '0px 20px 20px',
    minHeight                      : '600px',
    [theme.breakpoints.down('sm')] : {
      padding : '0px 0px 20px 0px'
    }
  },

  customFormWrapper : {
    padding                        : '0px 40px 0px',
    [theme.breakpoints.down('sm')] : {
      padding : '0px 0px 20px 0px'
    }
  },
  formDialogTitle : {
    borderBottom : `solid 1px ${dlsColor('grey4')}`
  },

  formTitle : {
    display        : 'flex',
    justifyContent : 'center',
    alignItems     : 'center'
  },

  formDialogContent : {
    overflow                       : 'unset',
    [theme.breakpoints.down('sm')] : {
      paddingTop : '0px'
    }
  },

  closeButton : {
    position  : 'absolute',
    left      : '19px',
    top       : '19px',
    '&:hover' : {
      cursor : 'pointer'
    }
  },

  form : {
    overflowY : 'auto'
  },

  overrides : {
    marginTop : '32px'
  },

  overridesTitle : {
    ...dlsAlt('maps', 'layer', 'listHeader'),
    color : dlsColor('grey1'),
    width : '100%'
  },
  
  overridesReportDetails : {
    ...dlsAlt('maps', 'layer', 'listHeader'),
    color      : dlsColor('grey1'),
    fontWeight : 'normal',
    width      : '30%'
  },

  overridesReportTitle : {
    ...dlsAlt('maps', 'layer', 'listHeader'),
    color      : dlsColor('grey1'),
    width      : '100%',
    fontWeight : 'normal'
  },
  
  overridesSwitches : {
    padding : '20px 5px'
  },

  primaryRecipientsLabel : {
    textAlign   : 'right',
    marginRight : '20px',
    fontSize    : '14px',
    color       : dlsColor('black')
  },
  primaryRecipientsEmail : {
    marginBottom : '16px'
  },
  emailSubjectLabel : {
    marginTop : '12px'
  },
  separateEmail : {
    fontSize      : '12px',
    textTransform : 'lowercase',
    fontWeight    : 'normal',
    letterSpacing : '0'
  },

  minusIcon : {
    marginBottom : '14px'
  },

  formActions : {
    borderTop                      : `solid 1px ${dlsColor('grey4')}`,
    [theme.breakpoints.down('sm')] : {
      justifyContent : 'space-between',
      padding        : '8px 16px 8px 40px'
    }
  },

  formSectionTitle : {
    ...dlsAlt('typography', 'cta3'),
    paddingLeft   : 16,
    textTransform : 'uppercase'
  },

  primaryButton : {
    width                          : '191px',
    marginRight                    : '28px',
    [theme.breakpoints.down('sm')] : {
      marginRight : '0px'
    }
  },
  loadingPlaceholder : {
    alignItems                     : 'center',
    color                          : dlsColor('grey3'),
    display                        : 'flex',
    height                         : '100%',
    marginLeft                     : '15px',
    paddingTop                     : '15px',
    [theme.breakpoints.down('sm')] : {
      marginLeft : '0px'
    }
  },

  endAdornment : {
    margin     : '0 10px',
    whiteSpace : 'nowrap'
  },

  leftPadInput : {
    paddingLeft : '11px',
    color       : dlsColor('grey1')
  },

  upperCase : {
    textTransform : 'uppercase'
  },

  revertCase : {
    textTransform : 'none ! important'
  },

  fieldClass : {
    color     : dlsColor('grey2'),
    marginTop : '30px',
    fontSize  : '14px'
  },

  tableHeader : {
    fontSize : '16px !important'
  },

  switchWrapper : {
    display    : 'flex',
    alignItems : 'center',
    height     : '100%',
    paddingTop : '12px'
  },

  infoLabel : {
    ...dlsAlt('typography', 'label2'),
    color         : dlsColor('grey3'),
    letterSpacing : 'normal'
  },

  formWrapperFilter : {
    padding                        : '0px 30px 0px',
    [theme.breakpoints.down('sm')] : {
      padding : '0px 0px 20px 0px'
    }
  },

  dateHeader : {
    fontSize : '14px !important',
    color    : '#828282'
  },

  dateError : {
    fontSize : '14px !important',
    color    : '#E2231A'
  },

  actionsTile : {
    display         : 'flex',
    justifyContent  : 'space-between',
    backgroundColor : 'white',
    padding         : 10,
    alignItems      : 'center'
  },

  reportActionsTile : {
    display         : 'flex',
    justifyContent  : 'space-between',
    backgroundColor : 'white',
    padding         : '0px 10px',
    alignItems      : 'center'
  },

  reportDuaration : {
    width      : '50%',
    fontFamily : 'Roboto',
    fontSize   : '14px'
  },

  reportError : {
    fontSize    : '12px',
    textAlign   : 'left',
    fontFamily  : 'Roboto',
    fontWeight  : '400',
    paddingLeft : '29px !important',
    color       : dlsColor('caRed'),
    lineHeight  : '0px'
  },
  requiredAsterisk : {
    color  : dlsColor('aaBlue'),
    margin : '0 2px'
  },
  datePickerItem : {
    zIndex : dlsZIndex('dateRangePicker')
  },
  modalHeadertext : {
    color      : dlsColor('grey1'),
    fontFamily : 'Neo Sans Std',
    fontSize   : '16px',
    fontWeight : '500',
    lineHeight : '24px',
    fontStyle  : 'normal'
  },
  modalSubtext : {
    color      : dlsColor('grey3'),
    fontFamily : 'Roboto',
    fontSize   : '14px',
    fontWeight : 'normal',
    lineHeight : '20px'
  },
  assetTypeChooserContainer : {
    display        : 'flex',
    justifyContent : 'flex-end',
    alignItems     : 'center',
    marginBottom   : '5px'
  },
  permissionTypeToggleButton : {
    position : 'absolute',
    left     : '12%'
  },
  chipContainer : {
    display   : 'flex',
    flexWrap  : 'wrap',
    maxHeight : '80px',
    overflowY : 'auto'
  },
  chipWrapper : {
    marginBottom : '10px',
    position     : 'relative'
  },
  body2 : {
    ...dlsTypography('body2'),
    fontSize   : '14px',
    lineHeight : '20px',
    margin     : '8px 0px'
  },
  contentRoot : {
    display       : 'flex',
    flexDirection : 'column',
    padding       : '0'
  },
  centered : {
    display        : 'flex',
    alignItems     : 'center',
    justifyContent : 'center',
    height         : '100%'
  }
});

export const getClasses = (classes) => ({
  paper            : classes.formPaper,
  paperScrollPaper : classes.paperScrollPaper,
  scrollPaper      : classes.scrollPaper
});

export default styles;
